import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MaterialModule } from '@material/material.module';

import { BatchOperationAdvanceRejectHiringManagerComponent } from './components/batch-operation-advance-reject-hiring-manager.component';

const components = [
  BatchOperationAdvanceRejectHiringManagerComponent,
];

@NgModule({
  declarations: components,
  imports: [
    CommonModule,
    MaterialModule,
  ],
  exports: components,
})
export class BatchOperationAdvanceRejectHiringManagerModule { }
